import { IonRow, IonCol } from '@ionic/react';
import React, { useEffect } from 'react';
import CompetitionsMenu from '../../components/ExchCompetitionsMenu/ExchCompetitionsMenu';
import InplayEventsTable from '../../components/ExchEventsTable/ExchInplayEventsTable';
import './ExchInplayEventsView.scss';
import {
  clearAllEvents,
  clearExchcngeBets,
  fetchInplayEvents,
  getInplayEvents,
} from '../../store';
import { connect } from 'react-redux';
import { EventDTO } from '../../models/common/EventDTO';
import { RootState } from '../../models/RootState';

type InplayEventsObj = {
  sportId: string;
  sportName: string;
  sportSlug: string;
  events: EventDTO[];
};

type StoreProps = {
  clearAllEvents: () => void;
  clearExchcngeBets: () => void;
  inplayEvents: InplayEventsObj[];
  fetchInplayEvents: () => void;
  loggedIn: boolean;
};

const ExchInplayEventsView: React.FC<StoreProps> = (props) => {
  const {
    clearAllEvents,
    clearExchcngeBets,
    inplayEvents,
    fetchInplayEvents,
    loggedIn,
  } = props;

  const updateEvents = () => {
    let iEvents: EventDTO[] = [];
    for (let ie of inplayEvents) {
      for (let iEvent of ie.events) {
        iEvents.push(iEvent);
      }
    }
    fetchInplayEvents();
  };

  useEffect(() => {
    clearAllEvents();
    clearExchcngeBets();
  }, []);

  useEffect(() => {
    updateEvents();
  }, [loggedIn]);

  useEffect(() => {
    let refreshInterval = setInterval(() => {
      updateEvents();
    }, 10000);
    return () => {
      clearInterval(refreshInterval);
    };
  }, []);

  return (
    <div>
      <IonRow className="exch-inplay-events-view">
        <IonCol className="exch-inplay-competitions-menu-section">
          <div className="sticky-col">
            <CompetitionsMenu />
          </div>
        </IonCol>
        <IonCol className="exch-inplay-events-table-section">
          <InplayEventsTable inplayEvents={inplayEvents} />
        </IonCol>
      </IonRow>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    inplayEvents: getInplayEvents(
      state.exchangeSports.events,
      state.common.contentConfig,
    ),
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    clearAllEvents: () => dispatch(clearAllEvents()),
    clearExchcngeBets: () => dispatch(clearExchcngeBets()),
    fetchInplayEvents: (inplayEvents: EventDTO[]) =>
      dispatch(fetchInplayEvents()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExchInplayEventsView);
